import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ChatService, ChatSettings } from '../../../services/chat.service';

@Component({
  selector: 'app-chat-settings-dialog',
  templateUrl: './chat-settings-dialog.component.html',
  styleUrl: './chat-settings-dialog.component.scss',
})
export class ChatSettingsDialogComponent implements OnInit {
  @Input() data?: ChatSettings;
  @Input() onComplete = (chatSettings: ChatSettings) => {};

  form: FormGroup;

  constructor(
    protected dialogRef: NbDialogRef<ChatSettingsDialogComponent>,
    protected fb: FormBuilder,
    protected nbToastrService: NbToastrService,
    protected chatService: ChatService
  ) {
    this.form = this.fb.group({
      widget_instance: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.data) {
      await this.chatService
        .updateChatSettings({
          ...this.data,
          ...(this.form.value as any),
        })
        .subscribe((d) => {
          this.onComplete(d.data);
          this.dialogRef.close();
        });
      return;
    }

    await this.chatService
      .createChatSettings({
        ...(this.form.value as any),
        styles: {},
      })
      .subscribe((d) => {
        this.onComplete(d.data);
        this.dialogRef.close();
      });
  }
}
